import { css } from "@emotion/react"

export const headerStyle = css`
	margin-bottom: 24px;
`

export const favoriteHeadingStyle = css`
	h2 {
		font-size: 28px;
		font-weight: 700;
		margin-bottom: 8px;
	}
`

export const itemsQuantityStyle = css`
	font-size: 16px;
	font-weight: 500;
`

export const actionsContainerStyle = css`
	width: 100%;
	display: flex;
	justify-content: flex-end;
	gap: 1rem;
	margin-top: 45px;
`
export const ctaClearFavoritesStyle = css`
	color: red;
	span {
		text-transform: capitalize !important;
		font-weight: 700 !important;
	}
`
export const ctaAddAllStyle = css`
	border-radius: 8px;
	padding: 16px 24px;
`
